import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'

export const pathKey = 'createSurvey' satisfies PathKey
